import _ from 'lodash'

import utility from '@/mixins/utility'

class Collection {

  #data = {}

  #libraries = []

  constructor(data={})
  {  
    this.#data = data

    this.#libraries = utility.methods.mapModels(data.libraries, 'library')
  }

  /**
   * Property getters.
   */
  
  get active()
  {
    return this.#data.active
  }

  get banner()
  {
    return this.#data.banner
  }

  get componentProps()
  {
    return this.#data.component_props || {}
  }

  get id()
  {
    return this.#data.id
  }

  get layout()
  {
    return this.#data.layout
  }

  get name()
  {
    return this.#data.name
  }

  get slug()
  {
    return this.#data.slug
  }


  /**
   * Relationships.
   */

  get libraries()
  {
    return this.#libraries
  }

  /**
   * Computed properties.
   */
  
  get hasLibraries()
  {
    return this.libraries.length > 0
  }

  get isGrid()
  {
    return this.#data.layout === 'grid'
  }

  get isMosaic()
  {
    return this.#data.layout === 'mosaic'
  }

  get sortedLibraries()
  {
    if( !this.hasLibraries )
      return []

    /**
     * @todo ordino per release date
     */
    return _.orderBy( this.libraries, ['updated_at'], ['desc'] )
  }
  
}

export default Collection